import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
    title = 'Star Lanka Tours Sri Lanka - Discover the Real Sri Lanka',
    description = 'Join Star Lanka Tours Sri Lanka for unforgettable travel experiences. We offer personalized tour packages, wildlife safaris, cultural journeys, beach holidays, Ayurveda retreats, and private guided tours across the island.',
    keywords = 'Star Lanka Tours, Star Lanka Tours Sri Lanka, Sri Lanka Tours, Travel Sri Lanka, Tour Packages Sri Lanka, Safari Sri Lanka, Cultural Tours Sri Lanka, Beach Holidays Sri Lanka, Private Tours Sri Lanka, Adventure Tours Sri Lanka, Nethaj Tours, Sri Lanka Travel Agency, Beruwala Tours,Betota,Galle,Ella, Sri Lanka Vacations, Wildlife Safaris Sri Lanka',
    image = '%PUBLIC_URL%/logo.png',           // ← update this path if your logo filename changed
    url = 'https://starlankatours.com',        // ← change to your real domain when ready
}) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Star Lanka Tours Sri Lanka" />

            {/* Open Graph (Facebook, WhatsApp, LinkedIn, etc.) */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Star Lanka Tours Sri Lanka" />

            {/* Twitter / X Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Optional extra tags for better SEO */}
            <meta name="robots" content="index, follow" />
            <meta name="googlebot" content="index, follow" />
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;